module.exports = __webpack_public_path__ + "static/media/error.4edea8f2.svg";